import Vue from 'vue'
import Vuetify from 'vuetify'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import 'vuetify/dist/vuetify.min.css'
import InfiniteLoading from 'vue-infinite-loading'
import { mask } from 'vue-the-mask'

import App from './App.vue'
import router from './router'
import store from './store'
import toast from './toast'
import createAPI from './api'

Vue.config.productionTip = false
Vue.use(Vuetify)
Vue.use(InfiniteLoading, {
  /* options */
})
Vue.directive('mask', mask)

Vue.use(toast)

const api = createAPI(() => store.getters.token)
store.$api = api

router.beforeEach((to, from, next) => {
  if (!to.matched.every(x => x.meta.public) && !store.getters.loggedIn)
    next({ name: 'error' })
  else next()
})
router.onError = err => {
  console.error(err)
}
function getValidationErrors(err) {
  // TODO: 401のtokenのexpireに対応
  let response = err.response
  if (response) {
    if (response.status === 400) {
      return response.data
    }
  }
  console.warn(err, response)
  return { nonFieldErrors: ['予期しないエラーが発生しました。'] }
}
Vue.prototype.$api = api
Vue.prototype.$getValidationErrors = getValidationErrors
Vue.prototype.$publicPath = process.env.BASE_URL || '/'
;(async () => {
  await store.dispatch('refresh')
  new Vue({
    router,
    store,
    api,
    getValidationErrors,
    vuetify: new Vuetify({
      theme: {
        themes: {
          light: {
            primary: '#370014',
          },
        },
      },
    }),
    render: h => h(App),
  }).$mount('#app')
})()
